import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { IconCaretDownFilled } from '@tabler/icons-react';


export default function MenuFilterDate() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div style={{marginBlock:'5px'}}>
      <Button
        id="demo-positioned-button"
        aria-controls={open ? 'demo-positioned-menu' : undefined}
        aria-haspopup="true"
        endIcon={<IconCaretDownFilled/>}
        sx={{width:'10rem',color:'grey',justifyContent:'space-between',border:'1px solid #E0E0E0  ','&:hover': {
          backgroundColor: 'white',
          border:'1.5px solid grey '
        },}}
        variant='outlined'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        Date
      </Button>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
                    <MenuItem >
                            <TextField focused type='date' label='From'/>
                    </MenuItem>
                    <MenuItem  >
                            <TextField focused type='date' label='To'/>
                    </MenuItem>       
      </Menu>
    </div>
  );
}

export  function MenuFilterAmount() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div style={{marginBlock:'5px'}}>
      <Button
        id="demo-positioned-button"
        aria-controls={open ? 'demo-positioned-menu' : undefined}
        aria-haspopup="true"
        endIcon={<IconCaretDownFilled/>}
        sx={{width:'10rem',color:'grey',justifyContent:'space-between',border:'1px solid #E0E0E0  ','&:hover': {
          backgroundColor: 'white',
          border:'1.5px solid grey '
        },}}        variant='outlined'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        Topup Amount
      </Button>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
                    <MenuItem >
                            <TextField  type='text' label='Min'/>
                    </MenuItem>
                    <MenuItem  >
                            <TextField  type='text' label='Max'/>
                    </MenuItem>       
      </Menu>
    </div>
  );
}


export const MenuFilterStatus=()=>{
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div style={{marginBlock:'5px'}}>
      <Button
        id="demo-positioned-button"
        aria-controls={open ? 'demo-positioned-menu' : undefined}
        aria-haspopup="true"
        sx={{width:'10rem',color:'grey',justifyContent:'space-between',border:'1px solid #E0E0E0  ','&:hover': {
          backgroundColor: 'white',
          border:'1.5px solid grey '
        },}}        endIcon={<IconCaretDownFilled/>}
        variant='outlined'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        Status
      </Button>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
                    <MenuItem>
                            <Button fullWidth sx={{color:'black'}}>Pending</Button>
                    </MenuItem>
                    <MenuItem  >
                         <Button fullWidth sx={{color:'black'}}>Successful</Button>
                    </MenuItem> 
                    <MenuItem  >
                         <Button fullWidth sx={{color:'black'}}>Failed</Button>
                    </MenuItem>       
      </Menu>
    </div>
  );
}